import { render, staticRenderFns } from "./paye-estimates-icon.vue?vue&type=template&id=87ce631e"
import script from "./paye-estimates-icon.vue?vue&type=script&lang=js"
export * from "./paye-estimates-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports